import {createElement, Component, PropTypes} from 'rlink-react';

import InputBase from './InputBase';
import {ContentImg} from 'rlink-repos/content-components';
import {Modal} from 'rlink-modal/component';


import {FormattedMessage} from 'react-intl';

import themeable from 'rlink-theme/themeable';
import Tooltip from 'rlink-tooltips/Tooltip';

import CSSScaleContentGroup from 'rlink-layout/components/CSSScaleContentGroup';

export default class ImagePickerInput extends InputBase {

  get choices () {
    return this.fromPropsOrContext('choices');
  }

  get modal () {
    return this.fromPropsOrContext('modal');
  }

  componentWillMount () {
    this.setState({
      picking: false,
      picked: null,
    });
  }

  get inputType () {
    return 'image-picker';
  }

  updatePicked (event, value) {
    let ev = event;
    ev.value = value;

    this.setState({
      picked: value,
      picking: false,
    }, () => {
      this.handleChange(event);
      this.fireCommitValue(ev, value);
    });
  }

  openPicker () {
    this.props.onOpenPicker(<CSSScaleContentGroup><div className={this.props.theme.ImagePicker}>
      <div className={this.props.theme.ImagePickerScrollContainer}>
        {this.choices.map((option, idx) => {
          let className = `${this.props.theme.PickableItem} ${(option.value === this.value)
            ? this.props.theme.Picked
            : ''}`;
          className += (!(option.pickable)) ? ` ${this.props.theme.Locked}` : '';
          return <Tooltip key={idx} content={option.tooltip}>
            <div key={idx} className={className}
              onClick={ev => (option.pickable)
                ? this.updatePicked(ev, option.value || option.src, option.external, option.src)
                : false}>
              {this.renderThumbnail({src: option.src, external: option.external})}
            </div>
          </Tooltip>;
        })}
      </div>
    {(this.props.showBackButton) && <Tooltip content={this.props.backButtonTooltip}>
        <a className={this.props.theme.BackButton}
        onClick={this.props.onClosePicker}>
          {this.props.backButtonLabel}
        </a>
      </Tooltip>
    }
    </div></CSSScaleContentGroup>);
  }

  renderInput () {
    let picked = this.choices.find(choice => (this.value === choice.value));
    return (<div>
      <a
        className={this.props.theme.Input + ' ' + this.props.theme.InputImagePicker}
        onClick={() => this.openPicker()}>
        {(picked && this.renderThumbnail({src: picked.src, external: picked.external}))}
        <span className={this.props.theme.Label}>{this.label}</span>
      </a>
    </div>);
  }

  renderThumbnail ({src, external = false}) {
    return (external)
      ? <img src={src} className={this.props.theme.Thumbnail} />
      : <ContentImg src={src} className={`${this.props.theme.Thumbnail}`} />;
  }

  renderLabel () {
    return null;
  }
}

ImagePickerInput.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    external: PropTypes.bool,
  })),
  label: PropTypes.node,
  modal: PropTypes.bool,
  showBackButton: PropTypes.bool,
  backButtonLabel: PropTypes.node,
  onOpenPicker: PropTypes.func,
};

ImagePickerInput.defaultProps = {
  choices: [],
  modal: true,
  label: 'Pick an Image',
  backButtonLabel: <FormattedMessage
    id="ui.label.button.imagepicker.DISMISS"
    defaultMessage="Back"
    description="Used in an image selection input that returns users to a previous state." />,
  backButtonTooltip: <FormattedMessage
    id="ui.text.info.imagepicker.DISMISS_TOOLTIP"
    defaultMessage="Close the image picker menu"
    description="A tooltip that appears when the user hovers over the dismiss button." />,
};

themeable(ImagePickerInput, {
  classes: [
    'Label',
    'Input',
    'InputImagePicker',
    'ImagePicker',
    'ImagePickerScrollContainer',
    'PickableItem',
    'Locked',
    'Picked',
    'Thumbnail',
    'modal-overlay',
    'modal',
    'modal-open',
    'BackButton',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/ImagePickerInput.jsx